module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAARBJREFUKBWNkj1rAkEQhs8YTGERBQtLC8VCiFbaiU3AYKNY2aVKkzKNPyOIhYKtP8BfYGMtFoISBBub2AiKwQ9En4FdWcN57MBzMzvvO3t7y/kd+4hircMzTP2WcyF8XxCBOBwfeNjEDtPGML7avDHBwBJGkIEg9MAzqqhtyCuXHLUotdcb39BLYiJeYA0TmIFz7xsLaGUxGCEbBfTabTCHWNMGleVivuGg+/8H0wjvWlT5jyxDv2bfHEwifIDZ27NuwAJuQptidD/h0VCP1E2YG71rqQcrdJ6uXcc5Ubfgx+jdlDIYBjmmjjNFB8a64ZblaFnwKVFurQtDtb6bZFCufwV9GMAWrCKFy+sPct3kAoGVJf1TxsMrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/icon_edit_black_7_8.png
// module id = ./src/_asset/sources/assets/images/icon_edit_black_7_8.png
// module chunks = main